import React from 'react';

import {
  currency,
  mapAgreementType,
  lastBusinessDay,
} from '../../../utils/dashboard-utils';

const toggle = (e) => {
  try {
    var tbodyClasses = e.target.parentElement.parentElement.classList;
    if (tbodyClasses.contains('exp')) {
      tbodyClasses.remove('exp');
    } else {
      tbodyClasses.add('exp');
    }
  } catch (err) {
    console.log('Error Expanding', err);
  }
};

const AgreementTypeMobile = (props) => {
  if (props) {
    return (
      <tbody>
        <tr className="account accodion">
          <td className="name" onClick={(e) => toggle(e)}>
            {mapAgreementType(props.agreementType.agreementTypeName)}
          </td>
          <td className="account-balance">
            {currency(props.agreementType.subTotalAccountBalanceAgreementLevel)}
          </td>
          <td className="expData"></td>
        </tr>
        <tr>
          <td className="expData">
            {lastBusinessDay(props.currentRmdYear)} Ending
          </td>
          <td className="expData account-balance">
            {currency(props.agreementType.subTotalAccountBalanceAgreementLevel)}
          </td>
        </tr>
        <tr>
          <td className="expData">{props.currentRmdYear} RMD</td>
          <td className="expData year-rmd">
            {currency(props.agreementType.subTotatRMDTotalAgreementLevel)}
          </td>
        </tr>
        {props.showYTDColumns ? (
          <tr>
            <td className="expData">YTD Distributions</td>
            <td className="expData distributions-ytd">
              {currency(props.agreementType.subTotalDistributionAgreementLevel)}
            </td>
          </tr>
        ) : null}
        {props.showYTDColumns ? (
          <tr>
            <td className="expData">Remaining for the year</td>
            {props.planName === 'IRA' || props.planName === '403(b)' ? (
              <td className="expData remaining-year">
                {currency(
                  props.agreementType.subTotalRemainingYearAgreementLevel
                )}
              </td>
            ) : (
              <td className="expData remaining-year">
                {' '}
                <div className="greyedout"></div>
              </td>
            )}
          </tr>
        ) : null}
        {props.showYTDColumns ? (
          <tr>
            <td className="expData">YTD Tax Withholding</td>
            <td className="expData tax-ytd">
              {currency(
                props.agreementType.subTotalTaxWithHoldingsAgreementLevel
              )}
            </td>
          </tr>
        ) : null}
        <tr className="account btmLine">
          <td colSpan={2}></td>
        </tr>
      </tbody>
    );
  }
  return null;
};

export default AgreementTypeMobile;
